import * as React from "react";
import { ODataParams, Query } from "../../../Components/Query";
import DocumentTitle from "../../../misc/components/DocumentTitle";
import { PFTSessionListTable } from "../../Shared/PFTSessionListTable";
import {
    OverreadChallengeStatusEnum,
    OverreadStatusIdEnum,
    Permission,
} from "../../../misc/api/apiTypes";
import { HamburgerMenu } from "../../../misc/components/HamburgerMenu";
import { Authorization } from "../../../misc/components/Authorization";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";
import { Link } from "react-router-dom";
import { SessionTypes } from "../../../misc/api/ApiSessionTypes";
import { SpirometryAnalysisSetTypeEnum } from "../../../misc/api/ApiSpirometryAnalysisSetType";
import { FvcSession, WebPortalClient } from "webportalclient";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient } from "../../../misc/api/WebPortalTokenClient";
import { DeviceTypes } from "../../../misc/api/apiTypes";


export const SpirometrySessionListScreen = ({ }): JSX.Element => {

    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();
    const [isModalVisible, setModalVisible] = React.useState(false);

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `visit/subject/site/studyId eq ${study.id}`;

        const select = 'id,name,occurred,visit,technician,lastReceived,status,testsCount,analysisSets,deviceType,challengeIsClosed,overreadChallengeStatus,overreadStatus';

       
        const expand = 'visit($select=id,name,visitScheduleItemId,subjectId;$expand=subject($select=id,number,siteId;$expand=site($select=id,number,studyId))),analysisSets($select=id,type,status,user),tests($count=true)';

        return await client.client.getFvcSessions(select, filter, params.orderby, expand, params.top, params.skip, undefined, true);
    }

    const RenderHamburgerMenu = (
        session: FvcSession,
        currentPermissions: Permission[],
        currentStudyId: string
    ) => {
        const hamburgerMenuPermissions = [
            PermissionEnum.AccessSingleFvcSession,
            PermissionEnum.SiteReviewFvcSession
        ]
        const hamburgerMenuDisabled = !currentPermissions.some(x => hamburgerMenuPermissions.some(e => e === x.Id));

        const anSet = session.analysisSets.find(a => a.type === SpirometryAnalysisSetTypeEnum.Overread);
        const { fvcSettings } = useCurrentStudyConfigurationContext();
        const overreadAnalysisSet = session.analysisSets.find(a => a.type === SpirometryAnalysisSetTypeEnum.Overread);
        const siteAnalysisSet = session.analysisSets.find(a => a.type === SpirometryAnalysisSetTypeEnum.Site);
        const challengeOverreadDecision = session.deviceType !== DeviceTypes.Spirotrac6 && session.deviceType !== DeviceTypes.Spirotrac5
            ? (session.analysisSets.find(a => a.type === SpirometryAnalysisSetTypeEnum.Overread && (a.status === OverreadStatusIdEnum.Rejected || a.status === OverreadStatusIdEnum.Accepted)) && fvcSettings.TechnicianChallengeOverreaderDecision)
            : false;

        return (
            <HamburgerMenu disabled={hamburgerMenuDisabled}>
                {!!overreadAnalysisSet && overreadAnalysisSet.status !== OverreadStatusIdEnum.NotStarted ? (
                    <Authorization
                        permissionId={PermissionEnum.AccessSingleFvcSession}
                        studyId={currentStudyId}
                        currentPermissions={currentPermissions}>
                        <li>
                            <Link to={`/spirometry/analysis/${overreadAnalysisSet.id}/view`}>View</Link>
                        </li>
                    </Authorization>
                ) : null}
                {!!siteAnalysisSet ? (
                    <Authorization
                        permissionId={PermissionEnum.SiteReviewFvcSession}
                        studyId={currentStudyId}
                        currentPermissions={currentPermissions}>
                        <li>
                            <Link to={`/spirometry/siteanalysis/${siteAnalysisSet.id}/edit`}>Review</Link>
                        </li>
                    </Authorization>
                ) : null}
                {!!challengeOverreadDecision ? (
                        <li>
                            <Link to={`/spirometry/${siteAnalysisSet.id}/challengedecision`} onClick={() => setModalVisible(true)}>Challenge Over-read Decision</Link>
                        </li>
                ) : null}
            </HamburgerMenu>
        );
    };

    return (
        <DocumentTitle title="FVC Sessions | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialOrdering={[{ field: "occurred", condition: "desc" }]}>
                <PFTSessionListTable
                    header="FVC Sessions"
                    sessionType={SessionTypes.Fvc}
                    hamburgerMenu={(session: FvcSession, currentPermissions: Permission[], currentStudyId: string) => {
                        return RenderHamburgerMenu(session, currentPermissions, currentStudyId);
                    }}
                />
            </Query>
        </DocumentTitle>
    );
};

export default SpirometrySessionListScreen;
